import getLocalString from "constants/Localization";
import { useDeleteProposalPlantProductMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteProposalPlantProduct() {
  const [mutation, { loading, data, error }] = useDeleteProposalPlantProductMutation({
    refetchQueries: ["customGetProposal"],
  });
  const [deleteProposalPlantProduct, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteProposalPlantProduct",
    },
    {
      failureMessage: getLocalString("proposals.delete-proposal-plant-product-failure"),
      successMessage: getLocalString("proposals.delete-proposal-plant-product-success"),
    }
  );
  return [deleteProposalPlantProduct, context] as const;
}
